import { css } from "@obby/components";

export const styles = {
  classReview: css({
    width: "100%",
    maxWidth: "450px",

    "@md": {
      width: "740px",
      maxWidth: "740px"
    }
  }),
  heading: css({
    fontFamily: "$foundersGroteskCondensed",
    fontWeight: "600",
    fontSize: "$mHeadingMobile",
    lineHeight: "$m-heading-lh",
    textTransform: "uppercase",
    color: "$ebonyClay",
    width: "100%",
    margin: "0",
    padding: "0 0 17px",
    textAlign: "center",

    "@md": {
      fontSize: "$mHeading"
    }
  }),

  list: css({
    width: "100%",
    display: "block",
    marginBottom: "25px",

    ".class-reviews__list-item": {
      width: "100%"
    }
  })
};
